import type { ModulePermissionShape } from "@/types/permissions";

export const contractorPermissionKeys = [
  "contractors_password_reset",
  "contractors_planned_hours_read",
] as const;

export type ContractorPermissions = ModulePermissionShape<
  typeof contractorPermissionKeys
>;
